(function () {
  const canvases = new WeakSet();

  function seeded(index) {
    const value = Math.sin(index * 93.173 + 17.91) * 43758.5453;
    return value - Math.floor(value);
  }

  function initialize(canvas) {
    if (canvases.has(canvas)) return;
    canvases.add(canvas);

    const context = canvas.getContext('2d');
    const media = canvas.closest('.vk-hero__media');
    const node = media && media.querySelector('[data-vk-market-node]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const labels = [
      'KC -3.5 | Model Edge: +2.1 pts',
      'PHI -2.0 | Price Delta: +1.4 pts',
      'BUF O47.5 | Market Edge: +3.2%',
      'DAL +1.5 | Signal Confidence: 78%'
    ];
    let width = 0;
    let height = 0;
    let pointer = null;
    let active = true;
    let frame = 0;

    function resize() {
      const rect = canvas.getBoundingClientRect();
      const scale = Math.min(window.devicePixelRatio || 1, 2);
      width = Math.max(1, rect.width);
      height = Math.max(1, rect.height);
      canvas.width = Math.round(width * scale);
      canvas.height = Math.round(height * scale);
      context.setTransform(scale, 0, 0, scale, 0, 0);
      draw(performance.now());
    }

    function drawGrid() {
      context.save();
      context.lineWidth = 1;
      context.font = '7px IBM Plex Mono, monospace';
      context.textAlign = 'center';
      context.textBaseline = 'middle';

      const top = height * 0.19;
      const bottom = height * 0.88;
      const left = width * 0.42;
      const right = width * 0.97;

      for (let index = 0; index <= 10; index += 1) {
        const x = left + ((right - left) * index) / 10;
        context.strokeStyle = index === 5 ? 'rgba(194,155,82,.17)' : 'rgba(255,255,255,.045)';
        context.beginPath();
        context.moveTo(x, top);
        context.lineTo(x, bottom);
        context.stroke();
        if (index > 0 && index < 10) {
          const yard = index <= 5 ? index * 10 : (10 - index) * 10;
          context.fillStyle = 'rgba(240,225,189,.12)';
          context.fillText(String(yard), x, bottom + 15);
        }
      }

      for (let index = 0; index <= 8; index += 1) {
        const y = top + ((bottom - top) * index) / 8;
        context.strokeStyle = 'rgba(255,255,255,.035)';
        context.beginPath();
        context.moveTo(left, y);
        context.lineTo(right, y);
        context.stroke();
      }

      context.restore();
    }

    function drawCandles(time) {
      const left = width * 0.45;
      const right = width * 0.96;
      const count = 20;
      const spacing = (right - left) / count;

      context.save();
      for (let index = 0; index < count; index += 1) {
        const x = left + index * spacing;
        const base = height * (0.68 - index * 0.012);
        const spread = 22 + seeded(index) * 46;
        const pulse = reduceMotion ? 0 : Math.sin(time / 1100 + index * 0.55) * 2;
        const up = seeded(index + 40) > 0.34;
        const bodyHeight = 5 + seeded(index + 80) * 12;
        context.strokeStyle = up ? 'rgba(223,194,124,.2)' : 'rgba(145,91,42,.16)';
        context.fillStyle = up ? 'rgba(194,155,82,.16)' : 'rgba(102,65,30,.13)';
        context.beginPath();
        context.moveTo(x, base - spread + pulse);
        context.lineTo(x, base + spread * 0.42 + pulse);
        context.stroke();
        context.fillRect(x - 2.2, base - bodyHeight * 0.5 + pulse, 4.4, bodyHeight);
      }
      context.restore();
    }

    function drawPointer() {
      if (!pointer) return;
      const gradient = context.createRadialGradient(pointer.x, pointer.y, 0, pointer.x, pointer.y, 58);
      gradient.addColorStop(0, 'rgba(234,211,154,.22)');
      gradient.addColorStop(0.18, 'rgba(194,155,82,.1)');
      gradient.addColorStop(1, 'rgba(194,155,82,0)');
      context.fillStyle = gradient;
      context.beginPath();
      context.arc(pointer.x, pointer.y, 58, 0, Math.PI * 2);
      context.fill();
      context.strokeStyle = 'rgba(234,211,154,.55)';
      context.beginPath();
      context.arc(pointer.x, pointer.y, 4, 0, Math.PI * 2);
      context.stroke();
    }

    function draw(time) {
      if (!context || !width || !height) return;
      context.clearRect(0, 0, width, height);
      drawGrid();
      drawCandles(time || 0);
      drawPointer();
    }

    function tick(time) {
      if (active && frame % 2 === 0) draw(time);
      frame += 1;
      window.requestAnimationFrame(tick);
    }

    canvas.addEventListener('pointermove', (event) => {
      const rect = canvas.getBoundingClientRect();
      pointer = { x: event.clientX - rect.left, y: event.clientY - rect.top };
      if (node && media) {
        const mediaRect = media.getBoundingClientRect();
        const labelIndex = Math.min(labels.length - 1, Math.floor((pointer.x / Math.max(width, 1)) * labels.length));
        node.textContent = labels[Math.max(0, labelIndex)];
        node.style.transform = `translate3d(${event.clientX - mediaRect.left + 13}px, ${event.clientY - mediaRect.top + 13}px, 0)`;
        node.classList.add('is-visible');
      }
      if (reduceMotion) draw(0);
    });

    canvas.addEventListener('pointerleave', () => {
      pointer = null;
      if (node) node.classList.remove('is-visible');
      if (reduceMotion) draw(0);
    });

    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    else window.addEventListener('resize', resize, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        active = entries[0] ? entries[0].isIntersecting : true;
      }).observe(canvas);
    }

    resize();
    if (!reduceMotion) window.requestAnimationFrame(tick);
  }

  function initializeAll(root) {
    const matches = root.matches && root.matches('[data-vk-market-canvas]') ? [root] : root.querySelectorAll('[data-vk-market-canvas]');
    matches.forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  else initializeAll(document);
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
